export default __webpack_public_path__ + "static/media/rnr-sports-table-10.446a10d3.webp";